// 定义client端全局变量
import moment from "moment";
import jQuery from 'jquery'
import {_} from 'vue-underscore'
import 'font-awesome/css/font-awesome.min.css'

moment.locale('zh-cn');  // 需要汉化
window.$ = jQuery; // 定义全局的jquery
window._ = _;
window.moment = moment;
window.hostUrl = window.location.origin;
window.serviceUrl = process.env.VUE_APP_GQL_URL || window.hostUrl;
window.isProduction = process.env.NODE_ENV === 'production';
